import { createApiDownloadExcel } from "services/config/api.config";
import { getAttachmentFromPath } from "utils/attachment.utils";
import StringFormat from "string-format";
import { ApiConstant } from "const";

export const getAvatar = data => createApiDownloadExcel().get(StringFormat(ApiConstant.GET_AVATAR, data));
